import React, { Component } from 'react';
import Slider from 'react-slick';
import { Link, withRouter } from 'react-router-dom';

import { Slider4 } from "../../../services/script"
import blog1 from "../../../assets/images/blog1.jpg"
import blog2 from "../../../assets/images/blog2.jpg"
import blog3 from "../../../assets/images/blog3.jpg"


class BlogSection extends Component {
 

    render() {

        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <Slider {...Slider4} className="slide-4 no-arrow ">
                            <div>
                                <div className="col-md-12">
                                    <Link to={`${process.env.PUBLIC_URL}/blog/details?id=1`} >
                                        <div className="classic-effect">
                                            <img src={blog3} className="img-fluid" alt="" />
                                            <span></span>
                                        </div>
                                    </Link>
                                    <div className="blog-details">
                                        <h4>27 مهر</h4>
                                        <Link to={`${process.env.PUBLIC_URL}/blog/details?id=1`} >
                                            <p>اتصال اسپاتیفای به اینترنت بدون vpn (فیلترشکن)</p></Link>
                                        <hr className="style1" />
                                        {/* <h6>27 مهر</h6> */}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="col-md-12">
                                    <Link to={`${process.env.PUBLIC_URL}/blog/details?id=2`} >
                                        <div className="classic-effect">
                                            <img src={blog2} className="img-fluid" alt="" />
                                            <span></span>
                                        </div>
                                    </Link>
                                    <div className="blog-details">
                                        <h4>27 مهر</h4>
                                        <Link to={`${process.env.PUBLIC_URL}/blog/details?id=2`} >
                                            <p>چگونه پلی لیست و آهنگها را در اسپاتیفای انتقال دهیم؟</p></Link>
                                        <hr className="style1" />
                                        {/* <h6>27 مهر</h6> */}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="col-md-12">
                                    <Link to={`${process.env.PUBLIC_URL}/blog/details?id=3`} >
                                        <div className="classic-effect">
                                            <img src={blog1} className="img-fluid" alt="" />
                                            <span></span>
                                        </div>
                                    </Link>
                                    <div className="blog-details">
                                        <h4>27 مهر</h4>
                                        <Link to={`${process.env.PUBLIC_URL}/blog/details?id=3`} >
                                            <p>ویزا کارت چیست و انواع کارت های آن کدام اند و چه کاربردی دارند؟ </p></Link>
                                        <hr className="style1" />
                                        {/* <h6>27 مهر</h6> */}
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(BlogSection);